import { v4 as uuidv4 } from "uuid";
import person from "../../../assets/images/person.svg"
import typeIcon from "../../../assets/images/breaking_news.svg"
import axios from "axios"
import Swal from "sweetalert2"

const {
    REACT_APP_GET_ACTIONS_ALERTS: GET_ACTIONS_ALERTS,
    REACT_APP_GET_ACTIONS_ALERTS_FILTERS: GET_ACTIONS_ALERTS_FILTERS,
    REACT_APP_MANUAL_UPDATE_ACTION: MANUAL_UPDATE_ACTION
} = process.env

export function reducer(state, action) {
    switch (action?.type) {
        case ACTIONS.setAlerts: {
            const { alerts = [], total } = action?.payload

            return {
                ...state,
                alerts,
                totalAlerts: total
            }
        }
        
        case ACTIONS.setOpenFilter:
            const updateOpenFilter = state.openFilter === action?.payload ? null : action?.payload
            
            return {
                ...state,
                openFilter: updateOpenFilter
            }

        case ACTIONS.setActiveFilter:
            const updatedActiveFilters = state.activeFilters.includes(action?.payload) ?
                                        state.activeFilters :
                                        [...state.activeFilters, action?.payload]

            return {
                ...state,
                searchValue: "",
                appliedSearchValue: "",
                currentPage: 1,
                activeFilters: updatedActiveFilters,
                filtersApplied: {
                    ...state.filtersApplied,
                    [action.payload]: state.filtersOptions[action.payload]
                }
            }

        case ACTIONS.setClearFilter:
            const newActiveFilters = state.activeFilters.filter(item => item !== action?.payload)


            return {
                ...state,
                currentPage: 1,
                filtersOptions: {
                    ...state.filtersOptions,
                    [action.payload]: []
                },
                filtersApplied: {
                    ...state.filtersApplied,
                    [action.payload]: []
                },
                activeFilters: newActiveFilters,
            }

        case ACTIONS.setFilterOptions:
            const prevFilterOptions = { ...state.filtersOptions }
            const filterProperty = action?.payload.property
            const filterOption = action?.payload.value

            const updatedOptionsList = prevFilterOptions?.[filterProperty].includes(filterOption) ?
                                        prevFilterOptions?.[filterProperty].filter(item => item !== filterOption) :
                                        [...prevFilterOptions[filterProperty], filterOption]

            return {
                ...state,
                filtersOptions: {
                    ...prevFilterOptions,
                    [filterProperty]: updatedOptionsList
                }
            }

        case ACTIONS.handleSort:
            const sortBy = action?.payload
            const directionOfSort = state.sortBy !== sortBy ? "ASC" : state.sortOrder === "ASC" ? "DSC" : "ASC" 
            
            return {
                ...state,
                sortOrder: directionOfSort,
                sortBy,
            }

        case ACTIONS.handleSearch:
            const searchValue = action?.payload

            return {
                ...state,
                searchValue,
            }

        case ACTIONS.applySearch: {
            const appliedSearchValue = state.searchValue

            if (appliedSearchValue === "") {
                return {
                    ...state,
                    appliedSearchValue: "",
                }
            }

            const clearFiltersOptions = FILTERS_MENU.reduce((acc, curr) => {
                acc[curr.accessKey] = []

                return acc
            }, {})
            
            return {
                ...state,
                appliedSearchValue,
                currentPage: 1,
                activeFilters: [],
                filtersOptions: clearFiltersOptions,
            }
        }
            
        case ACTIONS.handleCurrentPage:
            const currentPage = action?.payload

            return {
                ...state,
                currentPage
            }

        case ACTIONS.handleActionCompleted:
            const updatedAlert = action?.payload

            const updatedAlertsList = state.showHistoric ? state.alerts.map(alert => alert._id === updatedAlert._id ? {
                ...alert,
                completedBy: updatedAlert.completedBy,
            } : alert)
            :
            state.alerts.filter(alert => alert._id !== updatedAlert._id)

            return {
                ...state,
                alerts: updatedAlertsList
            }

        case ACTIONS.handleShowHistoric:
            return {
                ...state,
                showHistoric: !state.showHistoric,
            }

        case ACTIONS.handleMoreOptions:
            const alertID = action?.payload

            const moreOptionsOpen = alertID === state?.moreOptionsOpen ? null : alertID

            return {
                ...state,
                moreOptionsOpen
            }
            
        default:
            return state;
    }
}

export const PROPERTIES = {
    supplier: "companyName",
    typeOfAlert: "typeOfAction",
    client: "clientName",
    createdAt: "createdAt",
    completedBy: "completedBy"
}

const ROUTE_FOR_ALERT = {
    "Document uploaded": "/home/suppliers/supplierProfile/",
    "Ready for review": "/home/requests/reviewForAuth/",
    "New request": "/home/requests?companyName="
}

export const getRouteForAlert = (alert) => {
    const property = alert?.typeOfAction === "Document uploaded" && !alert?.isSupplierActive ? "Ready for review" : alert?.typeOfAction

    const preRoute = ROUTE_FOR_ALERT[property]

    return alert?.typeOfAction === "New request" ? preRoute + alert?.companyName : preRoute + alert?.supplierID + `?fromAlerts=${alert?.typeOfAction === "Document uploaded" ? "doc" : "review"}`
}

export const ACTIONS = {
    setAlerts: "SET_ALERTS",
    handleSearch: "SET_SEARCH_VALUE",
    applySearch: "APPLY_SEARCH_VALUE",
    setOpenFilter: "SET_OPEN_FILTER",
    setActiveFilter: "SET_ACTIVE_FILTER",
    setClearFilter: "SET_CLEAR_FILTER",
    setFilterOptions: "SET_FILTER_OPTIONS",
    handleSort: "HANDLE_SORT",
    handleCurrentPage: "HANDLE_CURRENT_PAGE",
    handleActionCompleted: "HANDLE_ACTION_COMPLETED",
    handleShowHistoric: "HANDLE_SHOW_HISTORIC",
    handleMoreOptions: "HANDLE_MORE_OPTIONS"
}

export const FILTERS_MENU = [
    {
        id: uuidv4(),
        title: "Supplier",
        accessKey: "supplier",
        icon: person
    },
    {
        id: uuidv4(),
        title: "Client",
        accessKey: "client",
        icon: person,
    },
    {
        id: uuidv4(),
        title: "Type of Alert",
        accessKey: "typeOfAlert",
        icon: typeIcon,
        items: ["Document uploaded", "New request", "Ready for review"]
    }
]

export const createSupplierFilter = (data) => {
    const filterSupplier = new Set(data?.map(supplier => supplier.companyName).filter(item => item))

    return Array.from(filterSupplier).sort()
}

export const createClientFilter = (data) => {
    const filterClient = new Set(data?.map(alert => alert?.clientName).filter(item => item))
    
    return Array.from(filterClient).sort()
}

export const getFiltersData = async ({ signal, params }) => {
    try {
        const query = new URLSearchParams(params).toString()
        
        const { data } = await axios.get(`${GET_ACTIONS_ALERTS_FILTERS}?${query}`, { signal })

        return data
    } catch (error) {
        if (error.name === "AbortError") return

        console.error("Error fetching filters data:", error)
    }
}

export const getAlerts = async ({ params, signal }) => {
    try {
        Swal.fire({
            footer: 'Loading, please wait',
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            didOpen: () => {
                Swal.showLoading()
            },
        })

        const { supplier, client, typeOfAction, ...rest } = params

        const query = new URLSearchParams(rest)

        if (supplier?.length > 0) supplier.forEach(s => query.append('supplier[]', s))
        
        if (client?.length > 0) client.forEach(c => query.append('client[]', c))

        if (typeOfAction?.length > 0) typeOfAction.forEach(t => query.append('typeOfAction[]', t))

        const { data } = await axios.get(`${GET_ACTIONS_ALERTS}?${query.toString()}`, { signal })

        Swal.close()
        
        return data
    } catch (error) {
        if (error.name === "AbortError") return
        
        Swal.fire({
            icon: "error",
            title: "Error",
            text: "An error occurred while fetching alerts.",
        })

        throw error.response?.data?.message
    }
}

export const updateAlert = async (action, userLogged) => {
    try {
        Swal.fire({
            toast: true,
            footer: 'Loading, please wait',
            showConfirmButton: false,
            position: "bottom-end",
            didOpen: () => {
                Swal.showLoading()
            },
        })

        const dataToSend = {
            userLogged,
        }

        const { data } = await axios.patch(`${MANUAL_UPDATE_ACTION}${action._id}`, dataToSend)

        Swal.close()

        return data.action
    } catch (err) {
        console.log(err.response?.data?.message)

        Swal.fire({
            icon: "error",
            title: "Error",
            text: "An error occurred while updating the alert.",
        })

        throw err.response?.data?.message
    }
}